import React, { useState, useEffect } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";

import { AiOutlineDelete } from "react-icons/ai";
import CustomDataGrid from "../ReusableComponent/DataGrid/CustomizeDataGrid";
import { Button } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { MdOutlinePreview } from "react-icons/md";
import { getGridSingleSelectOperators } from "@mui/x-data-grid";

export default function TemplateList(props) {
  const {
    tableRenderData,
    getCheckListDetails,
    setviewModeOnly,
    setDisableContinueButton,
    setSelectedTemplateData,
    handleActionButtons,
  } = props;
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [selectedTemplate, setSelectedTemplate] = useState("");

  const columns = [
    {
      field: "title",
      headerName: localization.title,
      hideable: false,
    },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    {
      field: "global",
      headerName: localization.global,
      valueGetter: (params) => {
        return params.row.anlagegruppeId ? localization.no : localization.yes;
      },
      filterOperators: getSelectionFilter(),
      type: "singleSelect",
      valueOptions: [
        { value: localization.yes, label: localization.yes },
        { value: localization.no, label: localization.no },
      ],
      width: 50,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "anlagegruppe",
      type: "string",
      headerName: localization.equipmentGroupNameCheckList,
      width: 100,
      valueGetter: (params) => {
        return params.row.anlagegruppe;
      },
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "plantId",
      type: "string",
      headerName: localization.plantid,
      width: 100,
      valueGetter: (params) => {
        return params.row.plantId;
      },
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "testGroup",
      type: "string",
      headerName: localization.testGroup,
      width: 100,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      type: "string",
      field: "kostGroup",
      headerName: localization.costCenterGroup,
      width: 100,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
    {
      field: "frequency",
      headerName: localization.frequenz,
      valueGetter: (params) => {
        const { frequency, duration } = params.row;

        if (frequency && frequency !== "A" && duration > 0) {
          const unit =
            frequency === "M"
              ? localization.month
              : frequency === "Y"
                ? localization.year
                : localization.day;

          return `${localization.every} ${duration} ${unit}`;
        } else if (frequency === "A") {
          return localization.anytime;
        }
      },
      width: 100,
      cellClassName: () => {
        return "MuiDataGridfdsfsd";
      },
    },
  ];

  useEffect(() => {
    if (selectedTemplate == "") {
      setDisableContinueButton(true);
    }
    return () => {};
  }, [selectedTemplate]);

  function getSelectionFilter() {
    return getGridSingleSelectOperators().filter(
      (operator) =>
        !["isnotempty", "isanyof", "not"].includes(
          operator.value.toLowerCase(),
        ),
    );
  }

  const handleView = (details) => {
    if (getCheckListDetails) {
      getCheckListDetails(details.id);
      setviewModeOnly(true);
    }

    // Code to open modal in view
  };

  const handleDelete = (templateId) => {
    const _idList = [];
    if (Array.isArray(templateId)) {
      templateId.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(templateId.id);
    }
    handleActionButtons("DELETE_TEMPLATE", _idList);
  };

  const handleSelectionChange = (selectionData) => {
    if (selectionData) {
      if (selectionData.length == 1) {
        setDisableContinueButton(false);
      } else {
        setDisableContinueButton(true);
      }
      setSelectedTemplate(selectionData);
      setSelectedTemplateData(selectionData);
    }
  };

  const operations = {
    RowOperationList: [
      { label: "View", component: <RenderViewButton />, onClick: handleView },
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
  };

  function RenderViewButton() {
    return (
      <>
        <Button
          variant="outlined"
          id="updateTicket"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<MdOutlinePreview />}
        >
          {localization.detailsTab}
        </Button>
      </>
    );
  }

  function RenderDeleteButton(props) {
    const id = props.currentBuild;
    return (
      <Button variant="outlined" startIcon={<AiOutlineDelete />}>
        {localization.delete}
      </Button>
    );
  }

  function getAction(params) {
    const _acionList = [];

    _acionList.push(
      <GridActionsCellItem
        label={localization.detailsTab}
        showInMenu
        onClick={() => handleView(params.row)}
        data-toggle="modal"
        data-target="#addDigitalChecklist"
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />,
    );

    return _acionList;
  }

  return (
    <div className="" id="content">
      {tableRenderData && (
        <CustomDataGrid
          Title=""
          columns={columns}
          rows={tableRenderData}
          operations={operations}
          onAdd={() => {}}
          showExport={true}
          showColumns={true}
          showFilters={true}
          showDensity={true}
          visibleColumns={[
            "title",
            "global",
            "anlagegruppe",
            "werkId",
            "testGroup",
            "kostGroup",
            "frequency",
          ]}
          showCheckBox={true}
          gridTableHeight={"dataGridSmall"}
          handleSelectionChange={handleSelectionChange}
        />
      )}
    </div>
  );
}
